import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/fire/compat/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { __awaiter } from 'tslib';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i2 from 'octali-lib-utils';
import * as i3 from 'octali-lib-firebase-utils';
import * as moment from 'moment';
import firebase from 'firebase/compat/app';

class OctaliLibShopService {
    constructor() { }
}
OctaliLibShopService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OctaliLibShopService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class OctaliLibShopComponent {
    constructor() { }
    ngOnInit() {
    }
}
OctaliLibShopComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OctaliLibShopComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: OctaliLibShopComponent, selector: "ctl-octali-lib-shop", ngImport: i0, template: `
    <p>
      octali-lib-shop works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ctl-octali-lib-shop',
                    template: `
    <p>
      octali-lib-shop works!
    </p>
  `,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

class OctaliLibShopModule {
}
OctaliLibShopModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OctaliLibShopModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopModule, declarations: [OctaliLibShopComponent], exports: [OctaliLibShopComponent] });
OctaliLibShopModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopModule, providers: [
        AngularFirestore,
    ], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibShopModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        OctaliLibShopComponent
                    ],
                    imports: [],
                    providers: [
                        AngularFirestore,
                    ],
                    exports: [
                        OctaliLibShopComponent
                    ]
                }]
        }] });

class CartDaoService {
    constructor(afStore, logger, userService) {
        this.afStore = afStore;
        this.logger = logger;
        this.userService = userService;
        this.cartsObs = new BehaviorSubject(null);
        this.cartObs = new BehaviorSubject(null);
        this.user = null;
        combineLatest([
            this.afStore.collection("carts").valueChanges(),
            this.userService.getUser()
        ]).pipe(map(([carts, user]) => {
            if (!user || user == null)
                return [];
            this.user = user;
            if (!carts || carts.length == 0)
                return [];
            return carts.filter(cart => {
                if (cart && user)
                    return cart.uid === user.uid;
                else
                    return false;
            });
        }), map((carts) => {
            for (let c of carts) {
                let products = new Map();
                let variations = new Map();
                let productsReturn = new Map();
                let variationsReturn = new Map();
                let categories = new Map();
                let categoriesReturn = new Map();
                for (let p of c.products)
                    products.set(p['id'], p['quantity']);
                for (let p of c.productsReturn)
                    productsReturn.set(p['id'], p['quantity']);
                for (let p of c.variations)
                    variations.set(p['id'], p['quantity']);
                for (let p of c.variationsReturn)
                    variationsReturn.set(p['id'], p['quantity']);
                for (let p of c.categories) {
                    let m = new Map();
                    if (categories.has(p['id']))
                        m = categories.get(p['id']);
                    m.set(p['price'], p['quantity']);
                    categories.set(p['id'], m);
                }
                for (let p of c.categoriesReturn) {
                    let m = new Map();
                    if (categoriesReturn.has(p['id']))
                        m = categoriesReturn.get(p['id']);
                    m.set(p['price'], p['quantity']);
                    categoriesReturn.set(p['id'], m);
                }
                c.products = products;
                c.productsReturn = productsReturn;
                c.variations = variations;
                c.variationsReturn = variationsReturn;
                c.categories = categories;
                c.categoriesReturn = categoriesReturn;
            }
            return carts;
        })).subscribe((cts) => __awaiter(this, void 0, void 0, function* () {
            this.logger.object(CartDaoService.name, this.user);
            if (this.user) {
                if (!cts || cts.length == 0) {
                    let cart = yield this.newCart();
                    if (cart != this.cartObs.getValue())
                        this.cartObs.next(cart);
                    if ([cart] != this.cartsObs.getValue())
                        this.cartsObs.next([cart]);
                }
                else {
                    for (let c of cts)
                        if (c.active) {
                            if (c != this.cartObs.getValue())
                                this.cartObs.next(c);
                        }
                    if (cts != this.cartsObs.getValue())
                        this.cartsObs.next(cts);
                }
            }
        }));
    }
    getCartsObs() {
        return this.cartsObs;
    }
    getCartObs() {
        return this.cartObs;
    }
    createId() {
        return this.afStore.createId();
    }
    setCart(datas) {
        let cart = this.getCartObs().getValue();
        if (cart == null)
            cart = this.emptyCart();
        if (cart.id === "") {
            cart.id = this.createId();
            datas.id = cart.id;
            return this.createCart(cart, datas);
        }
        else
            return this.updateCart(cart, datas);
    }
    createCart(cart, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("carts").doc(cart.id).set(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(cart);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.logger.message(CartDaoService.name, "create cart nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    updateCart(cart, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("carts").doc(cart.id).update(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(cart);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.logger.message(CartDaoService.name, "update cart nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    newCart() {
        return this.setCart(this.emptyCartDoc());
    }
    emptyCartDoc() {
        return {
            uid: this.user.uid,
            products: [],
            productsReturn: [],
            variations: [],
            variationsReturn: [],
            categories: [],
            categoriesReturn: [],
            coupons: [],
            nbItems: 0,
            active: true,
            updatedAt: ""
        };
    }
    emptyCart() {
        return {
            id: "",
            uid: this.user.uid,
            products: new Map(),
            productsReturn: new Map(),
            variations: new Map(),
            variationsReturn: new Map(),
            categories: new Map(),
            categoriesReturn: new Map(),
            coupons: [],
            nbItems: 0,
            active: true,
            updatedAt: ""
        };
    }
}
CartDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CartDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i3.UserService }], target: i0.ɵɵFactoryTarget.Injectable });
CartDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CartDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CartDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i3.UserService }]; } });

class CartService {
    constructor(dao, displayer) {
        this.dao = dao;
        this.displayer = displayer;
    }
    getCartObs() {
        return this.dao.getCartObs();
    }
    getCartsObs() {
        return this.dao.getCartsObs();
    }
    addDeclination(declination, quantity, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            //let cart = this.getCart();
            if (declination) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (check && (declination.quantity == 0 || declination.quantity < cart.variations.get(declination.id) + quantity))
                        this.displayer.presentAlert("Stock insuffisant", "Quantité disponible : " + declination.quantity, "Désolé, notre stock est insuffisant");
                    else {
                        let qte = quantity;
                        if (cart.variations) {
                            if (cart.variations.has(declination.id))
                                qte += cart.variations.get(declination.id);
                        }
                        else
                            cart.variations = new Map();
                        cart.nbItems += quantity;
                        cart.variations.set(declination.id, qte);
                        let prods = [];
                        for (let p of cart.variations.keys())
                            prods.push({ id: p, quantity: cart.variations.get(p) });
                        this.dao.setCart({ "variations": prods, "nbItems": cart.nbItems });
                    }
                }
            }
        });
    }
    setDeclination(declination, quantity, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            //let cart = this.getCart();
            if (declination) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (check && (declination.quantity == 0 || declination.quantity < cart.variations.get(declination.id) + quantity))
                        this.displayer.presentAlert("Stock insuffisant", "Quantité disponible : " + declination.quantity, "Désolé, notre stock est insuffisant");
                    else {
                        if (cart.variations) {
                            if (cart.variations.has(declination.id)) {
                                let qte = cart.variations.get(declination.id);
                                cart.nbItems -= qte;
                            }
                        }
                        else
                            cart.variations = new Map();
                        cart.nbItems += quantity;
                        cart.variations.set(declination.id, quantity);
                        let variations = [];
                        for (let p of cart.variations.keys())
                            variations.push({ id: p, quantity: cart.variations.get(p) });
                        this.dao.setCart({ "variations": variations, "nbItems": cart.nbItems });
                    }
                }
            }
        });
    }
    addDeclinationReturn(declination, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            //let cart = this.getCart();
            if (declination) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    let qte = quantity;
                    if (cart.variationsReturn) {
                        if (cart.variationsReturn.has(declination.id))
                            qte += cart.variationsReturn.get(declination.id);
                    }
                    else
                        cart.variationsReturn = new Map();
                    cart.variationsReturn.set(declination.id, qte);
                    let prods = [];
                    for (let p of cart.variationsReturn.keys())
                        prods.push({ id: p, quantity: cart.variationsReturn.get(p) });
                    this.dao.setCart({ "variationsReturn": prods });
                }
            }
        });
    }
    setDeclinationReturn(declination, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            //let cart = this.getCart();
            if (declination) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (!cart.variationsReturn)
                        cart.variationsReturn = new Map();
                    cart.variationsReturn.set(declination.id, quantity);
                    let variations = [];
                    for (let p of cart.variationsReturn.keys())
                        variations.push({ id: p, quantity: cart.variationsReturn.get(p) });
                    this.dao.setCart({ "variationsReturn": variations });
                }
            }
        });
    }
    addCategory(category, quantity, price) {
        return __awaiter(this, void 0, void 0, function* () {
            if (category) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (!cart.categories)
                        cart.categories = new Map();
                    if (cart.categories.has(category.id)) { //--< categories existe déjà
                        let cat = cart.categories.get(category.id);
                        if (cat.has(price)) { //--< un produit a déjà le même prix, on ajuste la quantité
                            let qte = cat.get(price);
                            cat.set(price, qte + quantity);
                        }
                        else { //--< on insert le produit
                            cat.set(price, quantity);
                        }
                    }
                    else {
                        let ins = new Map();
                        ins.set(price, quantity);
                        cart.categories.set(category.id, ins);
                    }
                    cart.nbItems += quantity;
                    let categories = [];
                    for (let cats of cart.categories.keys()) {
                        let prices = cart.categories.get(cats);
                        for (let price of prices.keys())
                            categories.push({ id: cats, price: price, quantity: prices.get(price) });
                    }
                    this.dao.setCart({ "categories": categories, "nbItems": cart.nbItems });
                }
            }
        });
    }
    setCategory(category, quantity, price) {
        return __awaiter(this, void 0, void 0, function* () {
            if (category) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (!cart.categories)
                        cart.categories = new Map();
                    if (cart.categories.has(category.id)) { //--< categories existe déjà
                        let cat = cart.categories.get(category.id);
                        if (cat.has(price)) { //--< un produit a déjà le même prix, on remplace la quantité
                            let qte = cat.get(price);
                            cart.nbItems -= qte;
                            cat.set(price, quantity);
                        }
                        else { //--< on insert le produit
                            cat.set(price, quantity);
                        }
                    }
                    else {
                        let ins = new Map();
                        ins.set(price, quantity);
                        cart.categories.set(category.id, ins);
                    }
                    cart.nbItems += quantity;
                    let categories = [];
                    for (let cats of cart.categories.keys()) {
                        let prices = cart.categories.get(cats);
                        for (let price of prices.keys())
                            categories.push({ id: cats, price: price, quantity: prices.get(price) });
                    }
                    this.dao.setCart({ "categories": categories, "nbItems": cart.nbItems });
                }
            }
        });
    }
    addCategoryReturn(category, quantity, price) {
        return __awaiter(this, void 0, void 0, function* () {
            if (category) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (!cart.categoriesReturn)
                        cart.categoriesReturn = new Map();
                    if (cart.categoriesReturn.has(category.id)) { //--< categories existe déjà
                        let cat = cart.categoriesReturn.get(category.id);
                        if (cat.has(price)) { //--< un produit a déjà le même prix, on ajuste la quantité
                            let qte = cat.get(price);
                            cat.set(price, qte + quantity);
                        }
                        else { //--< on insert le produit
                            cat.set(price, quantity);
                        }
                    }
                    else {
                        let ins = new Map();
                        ins.set(price, quantity);
                        cart.categoriesReturn.set(category.id, ins);
                    }
                    let categories = [];
                    for (let cats of cart.categoriesReturn.keys()) {
                        let prices = cart.categoriesReturn.get(cats);
                        for (let price of prices.keys())
                            categories.push({ id: cats, price: price, quantity: prices.get(price) });
                    }
                    this.dao.setCart({ "categoriesReturn": categories });
                }
            }
        });
    }
    setCategoryReturn(category, quantity, price) {
        return __awaiter(this, void 0, void 0, function* () {
            if (category) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (!cart.categoriesReturn)
                        cart.categoriesReturn = new Map();
                    if (cart.categoriesReturn.has(category.id)) { //--< categories existe déjà
                        let cat = cart.categoriesReturn.get(category.id);
                        cat.set(price, quantity);
                    }
                    else {
                        let ins = new Map();
                        ins.set(price, quantity);
                        cart.categoriesReturn.set(category.id, ins);
                    }
                    let categories = [];
                    for (let cats of cart.categoriesReturn.keys()) {
                        let prices = cart.categoriesReturn.get(cats);
                        for (let price of prices.keys())
                            categories.push({ id: cats, price: price, quantity: prices.get(price) });
                    }
                    this.dao.setCart({ "categoriesReturn": categories });
                }
            }
        });
    }
    addProduct(product, quantity, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (product) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (check && (product.quantity == 0 || product.quantity < cart.products.get(product.id) + quantity))
                        this.displayer.presentAlert("Stock insuffisant", "Quantité disponible : " + product.quantity, "Désolé, notre stock est insuffisant");
                    else {
                        let qte = quantity;
                        if (cart.products) {
                            if (cart.products.has(product.id))
                                qte += cart.products.get(product.id);
                        }
                        else
                            cart.products = new Map();
                        cart.nbItems += quantity;
                        cart.products.set(product.id, qte);
                        let prods = [];
                        for (let p of cart.products.keys())
                            prods.push({ id: p, quantity: cart.products.get(p) });
                        this.dao.setCart({ "products": prods, "nbItems": cart.nbItems });
                    }
                }
            }
        });
    }
    setProduct(product, quantity, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (product) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (check && (product.quantity == 0 || product.quantity < cart.products.get(product.id) + quantity))
                        this.displayer.presentAlert("Stock insuffisant", "Quantité disponible : " + product.quantity, "Désolé, notre stock est insuffisant");
                    else {
                        if (cart.products) {
                            if (cart.products.has(product.id)) {
                                let qte = cart.products.get(product.id);
                                cart.nbItems -= qte;
                            }
                        }
                        else
                            cart.products = new Map();
                        cart.nbItems += quantity;
                        cart.products.set(product.id, quantity);
                        let prods = [];
                        for (let p of cart.products.keys())
                            prods.push({ id: p, quantity: cart.products.get(p) });
                        this.dao.setCart({ "products": prods, "nbItems": cart.nbItems });
                    }
                }
            }
        });
    }
    addProductReturn(product, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            if (product) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    let qte = quantity;
                    if (cart.productsReturn) {
                        if (cart.productsReturn.has(product.id))
                            qte += cart.productsReturn.get(product.id);
                    }
                    else
                        cart.productsReturn = new Map();
                    cart.productsReturn.set(product.id, qte);
                    let prods = [];
                    for (let p of cart.productsReturn.keys())
                        prods.push({ id: p, quantity: cart.productsReturn.get(p) });
                    this.dao.setCart({ "productsReturn": prods });
                }
            }
        });
    }
    setProductReturn(product, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            if (product) {
                let cart = this.getCartObs().getValue();
                if (cart) {
                    if (!cart.productsReturn)
                        cart.productsReturn = new Map();
                    cart.productsReturn.set(product.id, quantity);
                    let prods = [];
                    for (let p of cart.productsReturn.keys())
                        prods.push({ id: p, quantity: cart.productsReturn.get(p) });
                    this.dao.setCart({ "productsReturn": prods });
                }
            }
        });
    }
    removeItemProduct(id) {
        let cart = this.getCartObs().getValue();
        if (cart) {
            let nb = cart.products.get(id);
            cart.products.delete(id);
            cart.nbItems -= nb;
            let prods = [];
            for (let p of cart.products.keys())
                prods.push({ id: p, quantity: cart.products.get(p) });
            this.dao.setCart({ "products": prods, "nbItems": cart.nbItems });
        }
    }
    removeItemProductReturn(id) {
        let cart = this.getCartObs().getValue();
        if (cart) {
            let nb = cart.productsReturn.get(id);
            cart.productsReturn.delete(id);
            let prods = [];
            for (let p of cart.productsReturn.keys())
                prods.push({ id: p, quantity: cart.productsReturn.get(p) });
            this.dao.setCart({ "productsReturn": prods });
        }
    }
    removeItemDeclination(id) {
        let cart = this.getCartObs().getValue();
        if (cart) {
            let nb = cart.variations.get(id);
            cart.variations.delete(id);
            cart.nbItems -= nb;
            let variations = [];
            for (let p of cart.variations.keys())
                variations.push({ id: p, quantity: cart.variations.get(p) });
            this.dao.setCart({ "variations": variations, "nbItems": cart.nbItems });
        }
    }
    removeItemDeclinationReturn(id) {
        let cart = this.getCartObs().getValue();
        if (cart) {
            let nb = cart.variationsReturn.get(id);
            cart.variationsReturn.delete(id);
            let variations = [];
            for (let p of cart.variationsReturn.keys())
                variations.push({ id: p, quantity: cart.variationsReturn.get(p) });
            this.dao.setCart({ "variationsReturn": variations });
        }
    }
    removeItemCategory(id, price) {
        let cart = this.getCartObs().getValue();
        if (cart && cart.categories.has(id)) {
            let nbP = cart.categories.get(id);
            let nb = 0;
            if (nbP.has(price)) { //--< il existe produit au prix
                nb = nbP.get(price);
                nbP.delete(price);
            }
            cart.nbItems -= nb;
            let categories = [];
            for (let cats of cart.categories.keys()) {
                let prices = cart.categories.get(cats);
                for (let price of prices.keys())
                    categories.push({ id: cats, price: price, quantity: prices.get(price) });
            }
            this.dao.setCart({ "categories": categories, "nbItems": cart.nbItems });
        }
    }
    removeItemCategoryReturn(id, price) {
        let cart = this.getCartObs().getValue();
        if (cart && cart.categoriesReturn.has(id)) {
            let nbP = cart.categoriesReturn.get(id);
            let nb = 0;
            if (nbP.has(price)) { //--< il existe produit au prix
                nb = nbP.get(price);
                nbP.delete(price);
            }
            let categories = [];
            for (let cats of cart.categoriesReturn.keys()) {
                let prices = cart.categoriesReturn.get(cats);
                for (let price of prices.keys())
                    categories.push({ id: cats, price: price, quantity: prices.get(price) });
            }
            this.dao.setCart({ "categoriesReturn": categories });
        }
    }
    removeAllItems(check = true) {
        if (check)
            this.displayer.presentAlertMultipleButtons("Suppression du panier", "cette action est irréversible", "Vous êtes sur le point de vider le panier actuel. Etes vous sur de vouloir continuer?", ["oui", "non"]).then(result => {
                if (result == "oui") {
                    this.dao.setCart({ products: [], variations: [], productsReturn: [], variationsReturn: [], categories: [], categoriesReturn: [], coupons: [], nbItems: 0 });
                }
            });
        else
            this.dao.setCart({ products: [], variations: [], productsReturn: [], variationsReturn: [], categories: [], categoriesReturn: [], coupons: [], nbItems: 0 });
    }
    newCart() {
        return this.dao.newCart();
    }
}
CartService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CartService, deps: [{ token: CartDaoService }, { token: i2.DisplayerService }], target: i0.ɵɵFactoryTarget.Injectable });
CartService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CartService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CartDaoService }, { type: i2.DisplayerService }]; } });

class CategoryDaoService {
    constructor(afStore, logger) {
        this.afStore = afStore;
        this.logger = logger;
        this.categoriesObs = new BehaviorSubject(null);
        this.categoriesIdObs = new BehaviorSubject(null);
        this.categoriesSubscription = this.afStore.collection("categories").valueChanges()
            .pipe(map(categories => categories))
            .subscribe(categories => {
            this.logger.object(CategoryDaoService.name, categories);
            let categoriesId = new Map();
            for (let cat of categories)
                categoriesId.set(cat.id, cat);
            this.categoriesObs.next(categories);
            this.categoriesIdObs.next(categoriesId);
        });
    }
    getCategoriesObs() {
        return this.categoriesObs;
    }
    getCategoriesIdObs() {
        return this.categoriesIdObs;
    }
}
CategoryDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CategoryDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
CategoryDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CategoryDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CategoryDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }]; } });

class CategoryService {
    constructor(dao) {
        this.dao = dao;
    }
    getCategoriesObs() {
        return this.dao.getCategoriesObs();
    }
    getCategoriesIdObs() {
        return this.dao.getCategoriesIdObs();
    }
}
CategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CategoryService, deps: [{ token: CategoryDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
CategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CategoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CategoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CategoryDaoService }]; } });

class ProductDaoService {
    constructor(afStore, logger, displayer) {
        this.afStore = afStore;
        this.logger = logger;
        this.displayer = displayer;
        this.productsObs = new BehaviorSubject(null);
        this.productsIdObs = new BehaviorSubject(null);
        this.productsEanObs = new BehaviorSubject(null);
        this.productsCatObs = new BehaviorSubject(null);
        this.productsStatutObs = new BehaviorSubject(null);
        this.productsManufacturerObs = new BehaviorSubject(null);
        this.afStore.collection("products", ref => { return ref.orderBy("title"); }).valueChanges().
            pipe(map(products => { return products; }), map(products => {
            for (let product of products) {
                let features = new Map();
                if (product.features)
                    for (let feature of product.features) {
                        features.set(feature['id'], feature["values"]);
                    }
                product.features = features;
            }
            return products;
        })).subscribe(products => {
            this.logger.object(ProductDaoService.name, products);
            let productsId = new Map();
            let productsEan = new Map();
            let productsCat = new Map();
            let productsStatut = new Map();
            let productsManufacturerObs = new Map();
            for (let product of products) {
                productsId.set(product.id, product);
                let eanProds = productsEan.get(product.ean);
                if (!eanProds) {
                    eanProds = new Array();
                    eanProds.push(product);
                }
                productsEan.set(product.ean, eanProds);
                let manufacturerProds = new Array();
                if (productsManufacturerObs.has(product.manufacturer) && productsManufacturerObs.get(product.manufacturer) != undefined) {
                    manufacturerProds = productsManufacturerObs.get(product.manufacturer);
                }
                manufacturerProds.push(product);
                productsManufacturerObs.set(product.manufacturer, manufacturerProds);
                let cats = product.categories;
                for (let cat of cats) {
                    let catProds = productsCat.get(cat);
                    if (!catProds)
                        catProds = new Array();
                    catProds.push(product);
                    productsCat.set(cat, catProds);
                }
                let statuts = [];
                if (productsStatut.has(product.statut) && productsStatut.get(product.statut) != undefined) {
                    statuts = productsStatut.get(product.statut);
                }
                statuts.push(product);
                productsStatut.set(product.statut, statuts);
            }
            this.productsObs.next(products);
            this.productsIdObs.next(productsId);
            this.productsEanObs.next(productsEan);
            this.productsCatObs.next(productsCat);
            this.productsStatutObs.next(productsStatut);
            this.productsManufacturerObs.next(productsManufacturerObs);
        });
    }
    ;
    getProductsObs() {
        return this.productsObs;
    }
    getProductsByIdObs() {
        return this.productsIdObs;
    }
    getProductsByEanObs() {
        return this.productsEanObs;
    }
    getProductsByCatObs() {
        return this.productsCatObs;
    }
    getProductsByStatutObs() {
        return this.productsStatutObs;
    }
    getProductsByManufacturerObs() {
        return this.productsManufacturerObs;
    }
    createId() {
        return this.afStore.createId();
    }
    setProduct(product, datas) {
        console.log(product, datas);
        if (product.id == null || product.id == "") {
            product.id = this.createId();
            datas.id = product.id;
            return this.createProduct(product, datas);
        }
        else
            return this.updateProduct(product, datas);
    }
    createProduct(product, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("products").doc(product.id).set(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(product);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.displayer.presentAlert("Erreur mise à jour", "Produit ", err);
                    this.logger.message(ProductDaoService.name, "create product nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    deleteProduct(productId) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            this.afStore.collection("products").doc(productId).delete().then(() => __awaiter(this, void 0, void 0, function* () {
                resolve(true);
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.displayer.presentAlert("Erreur suppression", "Produit ", err);
                this.logger.message(ProductDaoService.name, "delete product nok " + err, "error");
                reject(err);
            }));
        }));
    }
    updateProduct(product, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("products").doc(product.id).update(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(product);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.logger.message(ProductDaoService.name, "update product nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    updateQuantityProduct(productId, quantity, check) {
        const prodRef = this.afStore.collection("products").doc(productId).ref;
        return firebase.firestore().runTransaction(transaction => {
            return transaction.get(prodRef).then(prodDoc => {
                if (prodDoc.exists && prodDoc.data() != undefined) {
                    const newQuantity = Number(prodDoc.data()['quantity']) + quantity;
                    if (newQuantity < 0 && check)
                        return false;
                    else {
                        if (newQuantity < 0)
                            transaction.update(prodRef, { quantity: 0 });
                        else
                            transaction.update(prodRef, { quantity: newQuantity });
                        return true;
                    }
                }
                else
                    return false;
            }).catch(err => {
                this.logger.message(ProductDaoService.name, "update quantity product nok " + err, "error");
                return null;
            });
        }).then(res => {
            if (res == null)
                return false;
            else
                return res;
        }, err => { return false; });
    }
    getProductById(id) {
        return this.afStore.collection("products").doc(id).ref.get().then(product => {
            if (product.exists)
                return product.data();
            else
                return null;
        });
    }
}
ProductDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i2.DisplayerService }], target: i0.ɵɵFactoryTarget.Injectable });
ProductDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i2.DisplayerService }]; } });

class ManufacturerDaoService {
    constructor(afStore, logger, filesService, displayer) {
        this.afStore = afStore;
        this.logger = logger;
        this.filesService = filesService;
        this.displayer = displayer;
        this.manufacturersObs = new BehaviorSubject(null);
        this.manufacturersIdObs = new BehaviorSubject(null);
        this.manufacturersSubscription = this.afStore.collection("manufacturers").valueChanges()
            .pipe(map(manufacturers => manufacturers))
            .subscribe(manufacturers => {
            this.logger.object(ManufacturerDaoService.name, manufacturers);
            let manufacturersId = new Map();
            for (let manufacturer of manufacturers)
                manufacturersId.set(manufacturer.id, manufacturer);
            this.manufacturersObs.next(manufacturers);
            this.manufacturersIdObs.next(manufacturersId);
        });
    }
    getManufacturersObs() {
        return this.manufacturersObs;
    }
    getManufacturersIdObs() {
        return this.manufacturersIdObs;
    }
    setManufacturer(manufacturer, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (manufacturer.id != "")
                return yield this.updateManufacturer(manufacturer, display);
            else
                return yield this.createManufacturer(manufacturer, display);
        });
    }
    createManufacturer(manufacturer, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.displayer.presentLoader();
            const id = this.afStore.createId();
            manufacturer.id = id;
            manufacturer = yield this.setImage(manufacturer);
            return this.afStore.collection("manufacturers").doc(id).set(manufacturer).then(() => __awaiter(this, void 0, void 0, function* () {
                yield this.displayer.dismissLoader();
                if (display)
                    this.displayer.presentAlert("Création fournisseur", "Enregistrement réussi", "Bien joué, votre fournisseur a bien été créé.");
                return true;
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.message(ManufacturerDaoService.name, "create manufacturer nok ", "error");
                this.logger.object(ManufacturerDaoService.name, err, "error");
                yield this.displayer.dismissLoader();
                if (display)
                    this.displayer.presentAlert("Création fournisseur", "Echec de l'enregistrement", "Oups, une erreur est survenue, votre fournisseur n'a pas été créé.");
                return false;
            }));
        });
    }
    updateManufacturer(manufacturer, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.displayer.presentLoader();
            manufacturer = yield this.setImage(manufacturer);
            return this.afStore.collection("manufacturers").doc(manufacturer.id).update(manufacturer).then(() => __awaiter(this, void 0, void 0, function* () {
                yield this.displayer.dismissLoader();
                if (display)
                    this.displayer.presentAlert("Mise à jour fournisseur", "Enregistrement réussi", "Bien joué, votre fournisseur a bien été mis à jour.");
                return true;
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.message(ManufacturerDaoService.name, "update manufacturer nok ", "error");
                this.logger.object(ManufacturerDaoService.name, err, "error");
                yield this.displayer.dismissLoader();
                if (display)
                    this.displayer.presentAlert("Mise à jour fournisseur", "Echec de l'enregistrement", "Oups, une erreur est survenue, votre fournisseur n'a pas été mis à jour.");
                return false;
            }));
        });
    }
    setImage(manufacturer) {
        return __awaiter(this, void 0, void 0, function* () {
            let thumb = manufacturer.thumb;
            let image = manufacturer.image;
            if (image != null && image.data != "" && image.data.substring(0, 4) == "data") {
                thumb = { data: "", extension: "", name: "" };
                thumb.name = image.name;
                thumb.extension = image.extension;
                thumb.data = yield this.filesService.resizeImage(image.data, image.extension);
                image.data = yield this.filesService.resizeImage(image.data, image.extension, 1000, 1000);
                manufacturer.thumb = thumb;
                manufacturer.image = image;
            }
            return manufacturer;
        });
    }
    getManufacturerById(id) {
        return this.afStore.collection("manufacturers").doc(id).ref.get().then(manufacturer => {
            if (manufacturer.exists)
                return manufacturer.data();
            else
                return null;
        });
    }
}
ManufacturerDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i3.FileService }, { token: i2.DisplayerService }], target: i0.ɵɵFactoryTarget.Injectable });
ManufacturerDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i3.FileService }, { type: i2.DisplayerService }]; } });

class ManufacturerService {
    constructor(dao) {
        this.dao = dao;
    }
    getManufacturerById(id) {
        return this.dao.getManufacturerById(id);
    }
    getManufacturersObs() {
        return this.dao.getManufacturersObs();
    }
    getManufacturersIdObs() {
        return this.dao.getManufacturersIdObs();
    }
    setManufacturer(manufacturer) {
        return this.dao.setManufacturer(manufacturer);
    }
    createManufacturer(manufacturer) {
        return this.dao.createManufacturer(manufacturer);
    }
    updateManufacturer(manufacturer) {
        return this.dao.updateManufacturer(manufacturer);
    }
}
ManufacturerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerService, deps: [{ token: ManufacturerDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
ManufacturerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ManufacturerDaoService }]; } });

class ProductService {
    constructor(dao, fileService, displayer, manufacturerService) {
        this.dao = dao;
        this.fileService = fileService;
        this.displayer = displayer;
        this.manufacturerService = manufacturerService;
    }
    getProductById(id) {
        return this.dao.getProductById(id);
    }
    getProductsObs() {
        return this.dao.getProductsObs();
    }
    getProductsByIdObs() {
        return this.dao.getProductsByIdObs();
    }
    getProductsByEanObs() {
        return this.dao.getProductsByEanObs();
    }
    getProductsByCatObs() {
        return this.dao.getProductsByCatObs();
    }
    getProductsByStatutObs() {
        return this.dao.getProductsByStatutObs();
    }
    getProductsByManufacturerObs() {
        return this.dao.getProductsByManufacturerObs();
    }
    setProduct(product, datas, display = true) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (display)
                yield this.displayer.presentLoader("Enregistrement " + product.title.toLowerCase() + " en cours ...");
            let manufacturersId = this.manufacturerService.getManufacturersIdObs().getValue();
            let manufacturer = manufacturersId === null || manufacturersId === void 0 ? void 0 : manufacturersId.get(product.manufacturer);
            if (product.image != null && product.image.data != "" && ((_a = product.image.data) === null || _a === void 0 ? void 0 : _a.substring(0, 4)) == "data") {
                try {
                    let nameFile = "";
                    let manufacturerName = "";
                    if (manufacturer) {
                        manufacturerName = manufacturer.name.replace(/\/|\s/g, "-").toLowerCase() + "/";
                    }
                    nameFile += product.title.replace(/\/|\s/g, "-").toLowerCase();
                    let extension = product.image.extension.split('/')[0];
                    let data = product.image.data;
                    let zoomDataResize = yield this.fileService.resizeImage(data, extension, 1500, 1500, 0.3);
                    let zoomData = yield this.fileService.uploadToPath("library/" + extension + "/products/" + manufacturerName + nameFile + "-large", zoomDataResize, product.image.extension);
                    if (!product.zoom) {
                        product.zoom = { data: zoomData, extension: product.image.extension, name: manufacturerName + nameFile + "-zoom" };
                    }
                    else
                        product.zoom.data = zoomData;
                    let thumbDataResize = yield this.fileService.resizeImage(data, extension, 250, 250, 0.3);
                    let thumbData = yield this.fileService.uploadToPath("library/" + extension + "/products/" + manufacturerName + nameFile + "-thumb", thumbDataResize, product.image.extension);
                    if (!product.thumb) {
                        product.thumb = { data: thumbData, extension: product.image.extension, name: manufacturerName + nameFile + "-thumb" };
                    }
                    else
                        product.thumb.data = thumbData;
                    let imageDataResize = yield this.fileService.resizeImage(data, extension, 800, 800, 0.3);
                    let imageData = yield this.fileService.uploadToPath("library/" + extension.split('/')[0] + "/products/" + manufacturerName + nameFile, imageDataResize, product.image.extension);
                    product.image.data = imageData;
                    product.image.name = (manufacturerName + nameFile).replace(/\/|\s/g, " - ");
                    datas.image = product.image;
                    datas.zoom = product.zoom;
                    datas.thumb = product.thumb;
                }
                catch (err) {
                    if (display)
                        yield this.displayer.dismissLoader();
                    reject(err);
                }
            }
            if (product.images != null && ((_b = product.images) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                for (let image of product.images) {
                    if (image != null && image.data != "" && image.data.substring(0, 4) == "data") {
                        try {
                            let nameFile = "";
                            let manufacturerName = "";
                            if (manufacturer) {
                                manufacturerName = manufacturer.name.replace(/\/|\s/g, "-").toLowerCase() + "/";
                            }
                            nameFile += product.title.replace(/\/|\s/g, "-").toLowerCase() + "_" + moment.now().toString();
                            //nameFile = (manufacturer.name+"_"+product.title.toLowerCase()).replace(/ /g,"-")+"_"+moment.now().toString();
                            let extension = image.extension.split('/')[0];
                            let data = image.data;
                            let imageDataResize = yield this.fileService.resizeImage(data, extension, 800, 800, 0.3);
                            image.data = yield this.fileService.uploadToPath("library/" + extension.split('/')[0] + "/products/" + manufacturerName + nameFile, imageDataResize, image.extension);
                        }
                        catch (err) {
                            if (display) {
                                yield this.displayer.dismissLoader();
                                yield this.displayer.presentAlert("Erreur enregistrement produit", "Erreur 1", "" + err);
                            }
                        }
                    }
                }
            }
            this.dao.setProduct(product, datas).then((result) => __awaiter(this, void 0, void 0, function* () {
                if (display)
                    yield this.displayer.dismissLoader();
                resolve(result);
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                if (display)
                    yield this.displayer.dismissLoader();
                reject(err);
            }));
        }));
    }
    removeImg(img, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (display)
                yield this.displayer.presentLoader("Supression des images ...");
            let del = yield this.fileService.deleteFile(img.data);
            if (display)
                yield this.displayer.dismissLoader();
            return del;
        });
    }
    updateQuantityProduct(productId, quantity, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield this.dao.updateQuantityProduct(productId, quantity, check);
            if (res == null)
                return false;
            return res;
        });
    }
    deleteProduct(productId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.dao.deleteProduct(productId);
        });
    }
}
ProductService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductService, deps: [{ token: ProductDaoService }, { token: i3.FileService }, { token: i2.DisplayerService }, { token: ManufacturerService }], target: i0.ɵɵFactoryTarget.Injectable });
ProductService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ProductDaoService }, { type: i3.FileService }, { type: i2.DisplayerService }, { type: ManufacturerService }]; } });

class DeclinationDaoService {
    constructor(afStore, logger, displayer, productService) {
        this.afStore = afStore;
        this.logger = logger;
        this.displayer = displayer;
        this.productService = productService;
        this.declinationsObs = new BehaviorSubject(null);
        this.declinationsIdObs = new BehaviorSubject(null);
        this.declinationsEanObs = new BehaviorSubject(null);
        this.afStore.collection("declinations").valueChanges().
            pipe(map(declinations => { return declinations; }), map(declinations => {
            for (let declination of declinations) {
                let vals = new Map();
                if (declination.values)
                    for (let v of declination.values)
                        vals.set(v['id'], v['value']);
                declination.values = vals;
            }
            return declinations;
        })).subscribe(declinations => {
            this.logger.object(DeclinationDaoService.name, declinations);
            let declinationsId = new Map();
            let declinationsEan = new Map();
            for (let declination of declinations) {
                declinationsId.set(declination.id, declination);
                let eanDecls = declinationsEan.get(declination.ean);
                if (!eanDecls)
                    eanDecls = new Array();
                eanDecls.push(declination);
                declinationsEan.set(declination.ean, eanDecls);
            }
            this.declinationsObs.next(declinations);
            this.declinationsIdObs.next(declinationsId);
            this.declinationsEanObs.next(declinationsEan);
        });
    }
    ;
    createId() {
        return this.afStore.createId();
    }
    getDeclinationsObs() {
        return this.declinationsObs;
    }
    getDeclinationsByIdObs() {
        return this.declinationsIdObs;
    }
    getDeclinationsByEanObs() {
        return this.declinationsEanObs;
    }
    delDeclination(product, declination, display = true) {
        return new Promise(resolve => {
            let id = declination.id;
            this.afStore.collection("declinations").doc(id).delete().then(() => {
                let combinations = product.combinations;
                combinations.splice(combinations.indexOf(id), 1);
                product.combinations = combinations;
                this.productService.setProduct(product, { combinations: combinations }).then(() => {
                    resolve(true);
                }).catch(err => {
                    resolve(false);
                });
            }).catch(err => {
                resolve(false);
            });
        });
    }
    setDeclination(declination, datas) {
        if (declination.id == null || declination.id == "") {
            declination.id = this.createId();
            datas.id = declination.id;
            return this.createDeclination(declination, datas);
        }
        else
            return this.updateDeclination(declination, datas);
    }
    createDeclination(declination, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("declinations").doc(declination.id).set(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(declination);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.displayer.presentAlert("Erreur mise à jour", "Declination ", err);
                    this.logger.message(DeclinationDaoService.name, "update declination nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    updateDeclination(declination, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("declinations").doc(declination.id).update(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(declination);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.displayer.presentAlert("Erreur mise à jour", "Declination ", err);
                    this.logger.message(DeclinationDaoService.name, "update declination nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    updateQuantityDeclination(declinationId, quantity, check) {
        return __awaiter(this, void 0, void 0, function* () {
            const prodRef = yield this.afStore.collection("declinations").doc(declinationId).ref;
            return this.afStore.firestore.runTransaction(transaction => {
                return transaction.get(prodRef).then(declinationDoc => {
                    if (declinationDoc.exists && declinationDoc.data() != undefined) {
                        const newQuantity = Number(declinationDoc.data()['quantity']) + quantity;
                        if (newQuantity < 0 && check)
                            return false;
                        else {
                            if (newQuantity < 0)
                                transaction.update(prodRef, { quantity: 0 });
                            else
                                transaction.update(prodRef, { quantity: newQuantity });
                            return true;
                        }
                    }
                    else
                        return false;
                }).catch(err => {
                    this.logger.message(DeclinationDaoService.name, "update quantity declination nok " + err, "error");
                    return null;
                });
            }).then(res => {
                if (res == null)
                    return false;
                else
                    return res;
            }, err => { return false; });
        });
    }
    getDeclinationById(id) {
        return this.afStore.collection("declinations").doc(id).ref.get().then(declination => {
            if (declination.exists)
                return declination.data();
            else
                return null;
        });
    }
}
DeclinationDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i2.DisplayerService }, { token: ProductService }], target: i0.ɵɵFactoryTarget.Injectable });
DeclinationDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i2.DisplayerService }, { type: ProductService }]; } });

class VariationDaoService {
    constructor(afStore, logger) {
        this.afStore = afStore;
        this.logger = logger;
        this.variationsObs = new BehaviorSubject(null);
        this.variationsIdObs = new BehaviorSubject(null);
        this.variationsSubscription = this.afStore.collection("variations").valueChanges()
            .pipe(map(variations => variations))
            .subscribe(variations => {
            if (variations) {
                let variationsId = new Map();
                for (let feat of variations)
                    variationsId.set(feat.id, feat);
                this.variationsObs.next(variations);
                this.variationsIdObs.next(variationsId);
            }
        });
    }
    getVariationsObs() {
        return this.variationsObs;
    }
    getVariationsIdObs() {
        return this.variationsIdObs;
    }
    createId() {
        return this.afStore.createId();
    }
    setVariation(variation, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            if (variation.id == null || variation.id == "") {
                variation.id = this.createId();
                datas.id = variation.id;
                return yield this.createVariation(variation, datas);
            }
            else
                return yield this.updateVariation(variation, datas);
        });
    }
    createVariation(variation, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("variations").doc(variation.id).set(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(variation);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.logger.message(VariationDaoService.name, "update variation nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
    updateVariation(variation, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("variations").doc(variation.id).update(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                    resolve(variation);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    this.logger.message(VariationDaoService.name, "update variation nok " + err, "error");
                    reject(err);
                }));
            }));
        });
    }
}
VariationDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: VariationDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
VariationDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: VariationDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: VariationDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }]; } });

class VariationService {
    constructor(dao, displayer) {
        this.dao = dao;
        this.displayer = displayer;
    }
    getVariationsObs() {
        return this.dao.getVariationsObs();
    }
    getVariationsIdObs() {
        return this.dao.getVariationsIdObs();
    }
    setVariation(variation, datas, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (display)
                    yield this.displayer.presentLoader("Enregistrement variation en cours ...");
                this.dao.setVariation(variation, datas).then((result) => __awaiter(this, void 0, void 0, function* () {
                    if (display)
                        yield this.displayer.dismissLoader();
                    resolve(result);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    if (display)
                        yield this.displayer.dismissLoader();
                    reject(err);
                }));
            }));
        });
    }
    addVariationValue(variation, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                switch (variation.type) {
                    case "array":
                    case "string":
                    case "number":
                        this.displayer.presentValueAlert("Ajout " + variation.name, "", variation.nameValue, variation.typeValue, "Entrez une valeur de type " + variation.typeValue).then((value) => __awaiter(this, void 0, void 0, function* () {
                            if (value) {
                                if (variation.values.includes(value)) {
                                    this.displayer.presentAlert("Sors tes lunettes", variation.nameValue + " déjà utilisée", "Regarde mieux, " + value + " est déjà dans la liste.");
                                }
                                else {
                                    variation.values.push(value);
                                    yield this.setVariation(variation, { values: variation.values });
                                    resolve(value);
                                }
                            }
                            else
                                resolve(null);
                        }));
                        break;
                    case "map":
                        if (variation.typeValue[1] == "file") {
                            this.displayer.presentValueAlert("Ajout " + variation.name, "", variation.nameValue[0], variation.typeValue[0], "Entrez une valeur de type " + variation.typeValue[0], true).then((value) => __awaiter(this, void 0, void 0, function* () {
                                if (value && value[variation.nameValue[0]]) {
                                    if (variation.values.filter(val => { return val[variation.nameValue[0]] == value[variation.nameValue[0]]; }).length > 0) {
                                        this.displayer.presentAlert("Sors tes lunettes...", variation.nameValue + " déjà utilisée", "Regarde mieux, " + value[variation.nameValue[0]] + " est déjà dans la liste.");
                                        resolve(null);
                                    }
                                    else {
                                        variation.values.push(value);
                                        yield this.setVariation(variation, { values: variation.values });
                                        resolve(value);
                                    }
                                }
                                else
                                    resolve(null);
                            }));
                        }
                        else {
                            this.displayer.presentMapAlert("Ajout " + variation.name, "", variation.nameValue, variation.typeValue).then((values) => __awaiter(this, void 0, void 0, function* () {
                                if (values[variation.nameValue[0]] && values[variation.nameValue[1]]) {
                                    if (variation.values.filter(value => { return value[variation.nameValue[0]] == values[variation.nameValue[0]] && value[variation.nameValue[1]] == values[variation.nameValue[1]]; }).length > 0) {
                                        this.displayer.presentAlert("Sors tes lunettes...", variation.nameValue + " déjà utilisée", "Regarde mieux, " + values[variation.nameValue[0]] + "" + variation.display.separate + "" + values[variation.nameValue[1]] + " est déjà dans la liste.");
                                        resolve(null);
                                    }
                                    else {
                                        variation.values.push(values);
                                        yield this.setVariation(variation, { values: variation.values });
                                        resolve(values);
                                    }
                                }
                                else
                                    resolve(null);
                            }));
                        }
                        break;
                    default:
                        resolve(null);
                }
            });
        });
    }
}
VariationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: VariationService, deps: [{ token: VariationDaoService }, { token: i2.DisplayerService }], target: i0.ɵɵFactoryTarget.Injectable });
VariationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: VariationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: VariationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: VariationDaoService }, { type: i2.DisplayerService }]; } });

class DeclinationService {
    constructor(dao, displayer, fileService, manufacturerService, variationService) {
        this.dao = dao;
        this.displayer = displayer;
        this.fileService = fileService;
        this.manufacturerService = manufacturerService;
        this.variationService = variationService;
        this.subscription = null;
    }
    getDeclinationById(id) {
        return this.dao.getDeclinationById(id);
    }
    getDeclinationsObs() {
        return this.dao.getDeclinationsObs();
    }
    getDeclinationsByIdObs() {
        return this.dao.getDeclinationsByIdObs();
    }
    getDeclinationsByEanObs() {
        return this.dao.getDeclinationsByEanObs();
    }
    delDeclination(product, declination, display = true) {
        return this.dao.delDeclination(product, declination, display);
    }
    setDeclination(product, declination, datas, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (this.subscription)
                    this.unsubscribe();
                this.subscription = combineLatest([
                    this.variationService.getVariationsIdObs(),
                    this.manufacturerService.getManufacturersIdObs(),
                ]).subscribe(([variationsId, manufacturersId]) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    if (variationsId && manufacturersId) {
                        let manufacturer = manufacturersId.get(product.manufacturer);
                        let nameV = product.title;
                        for (let variation of product.variations) {
                            let v = variationsId.get(variation);
                            if (v) {
                                nameV += " " + v.nameValue;
                                if ((_a = declination.values) === null || _a === void 0 ? void 0 : _a.has(v.id))
                                    nameV += " " + ((_b = declination.values) === null || _b === void 0 ? void 0 : _b.get(v.id));
                            }
                        }
                        if (display)
                            yield this.displayer.presentLoader("Enregistrement " + nameV + " en cours ...");
                        if (declination.image != undefined && declination.image != null && declination.image != [])
                            if (declination.image.data.substring(0, 4) == "data") {
                                try {
                                    let nameFile = manufacturer.name.toLowerCase().replace(/ /g, "-") + "_";
                                    nameFile += nameV.toLowerCase().replace(/ /g, "-");
                                    const data = declination.image.data;
                                    const extension = declination.image.extension;
                                    const nameF = ("library/" + extension.split('/')[0] + "/products/" + nameFile).toLowerCase().replace(/ /g, "-");
                                    let imageDataResize = yield this.fileService.resizeImage(data, extension, 800, 800, 0.3);
                                    declination.image.data = yield this.fileService.uploadToPath(nameF, imageDataResize, extension);
                                    datas.image = { data: declination.image.data, extension: extension, name: nameFile };
                                    let zoomDataResize = yield this.fileService.resizeImage(data, extension, 1500, 1500, 0.3);
                                    declination.zoom.data = yield this.fileService.uploadToPath(nameF + "-large", zoomDataResize, extension);
                                    datas.zoom = { data: declination.zoom.data, extension: extension, name: nameFile + "-large" };
                                    if (!(declination.thumb != undefined && declination.thumb != null && declination.thumb != [])) {
                                        let thumbDataResize = yield this.fileService.resizeImage(data, extension, 250, 250, 0.3);
                                        declination.thumb.data = yield this.fileService.uploadToPath(nameF + "-thumb", thumbDataResize, extension);
                                        datas.thumb = { data: declination.thumb.data, extension: extension, name: nameFile + "-thumb" };
                                    }
                                }
                                catch (err) {
                                    if (display) {
                                        yield this.displayer.dismissLoader();
                                        yield this.displayer.presentAlert("Erreur chargement image principale variation", "Erreur 1", "" + err);
                                    }
                                }
                            }
                        if (declination.thumb != undefined && declination.thumb != null && declination.thumb != []) {
                            if (declination.thumb.data.substring(0, 4) == "data") {
                                try {
                                    let nameFile = manufacturer.name.toLowerCase().replace(/ /g, "-") + "_";
                                    nameFile += nameV.toLowerCase().replace(/ /g, "-");
                                    const data = declination.thumb.data;
                                    const extension = declination.thumb.extension;
                                    const nameF = ("library/" + extension.split('/')[0] + "/products/" + nameFile).toLowerCase().replace(/ /g, "-");
                                    let thumbDataResize = yield this.fileService.resizeImage(data, extension, 250, 250, 0.3);
                                    declination.thumb.data = yield this.fileService.uploadToPath(nameF + "-thumb", thumbDataResize, extension);
                                    datas.thumb = { data: declination.thumb.data, extension: extension, name: nameFile + "-thumb" };
                                }
                                catch (err) {
                                    if (display) {
                                        yield this.displayer.dismissLoader();
                                        yield this.displayer.presentAlert("Erreur chargement image principale variation", "Erreur 1", "" + err);
                                    }
                                }
                            }
                        }
                        if (declination.images && declination.images.length > 0)
                            for (let image of declination.images)
                                if (image != null && image.data != "" && image.data.substring(0, 4) == "data") {
                                    try {
                                        let nameFile = manufacturer.name.toLowerCase().replace(/ /g, "-") + "_";
                                        nameFile = nameV.toLowerCase().replace(/ /g, "-") + "_" + moment.now().toString();
                                        const extension = image.extension.split('/')[0];
                                        const data = image.data;
                                        let imageDataResize = yield this.fileService.resizeImage(data, extension, 800, 800, 0.3);
                                        image.data = yield this.fileService.uploadToPath("library/" + extension + "/products/" + nameFile, imageDataResize, extension);
                                    }
                                    catch (err) {
                                        if (display) {
                                            yield this.displayer.dismissLoader();
                                            yield this.displayer.presentAlert("Erreur chargement image variation", "Erreur 2", "" + err);
                                        }
                                    }
                                }
                        this.dao.setDeclination(declination, datas).then((result) => __awaiter(this, void 0, void 0, function* () {
                            if (display)
                                yield this.displayer.dismissLoader();
                            resolve(result);
                        })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                            if (display)
                                yield this.displayer.dismissLoader();
                            reject(err);
                        }));
                    }
                }));
            }));
        });
    }
    updateQuantityDeclination(declinationId, quantity, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.dao.updateQuantityDeclination(declinationId, quantity, check);
        });
    }
    removeImg(img, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (display)
                yield this.displayer.presentLoader("Supression des images ...");
            let del = yield this.fileService.deleteFile(img.data);
            if (display)
                yield this.displayer.dismissLoader();
            return del;
        });
    }
    unsubscribe() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
DeclinationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationService, deps: [{ token: DeclinationDaoService }, { token: i2.DisplayerService }, { token: i3.FileService }, { token: ManufacturerService }, { token: VariationService }], target: i0.ɵɵFactoryTarget.Injectable });
DeclinationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: DeclinationDaoService }, { type: i2.DisplayerService }, { type: i3.FileService }, { type: ManufacturerService }, { type: VariationService }]; } });

class FeatureDaoService {
    constructor(afStore, logger) {
        this.afStore = afStore;
        this.logger = logger;
        this.featuresObs = new BehaviorSubject(null);
        this.featuresIdObs = new BehaviorSubject(null);
        this.featuresSubscription = this.afStore.collection("features").valueChanges()
            .pipe(map(features => features))
            .subscribe(features => {
            this.logger.object(FeatureDaoService.name, features);
            let featuresId = new Map();
            for (let feat of features)
                featuresId.set(feat.id, feat);
            this.featuresObs.next(features);
            this.featuresIdObs.next(featuresId);
        });
    }
    getFeaturesObs() {
        return this.featuresObs;
    }
    getFeaturesIdObs() {
        return this.featuresIdObs;
    }
    createId() {
        return this.afStore.createId();
    }
    setFeature(feature, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            if (feature.id == null || feature.id == "") {
                feature.id = this.createId();
                datas.id = feature.id;
                return this.createFeature(feature, datas);
            }
            else
                return this.updateFeature(feature, datas);
        });
    }
    createFeature(feature, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("features").doc(feature.id).set(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                return feature;
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.message(FeatureDaoService.name, "create feature nok ", "error");
                this.logger.object(FeatureDaoService.name, err, "error");
                return null;
            }));
        });
    }
    updateFeature(feature, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("features").doc(feature.id).update(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                return feature;
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.message(FeatureDaoService.name, "update feature nok ", "error");
                this.logger.object(FeatureDaoService.name, err, "error");
                return null;
            }));
        });
    }
}
FeatureDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FeatureDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
FeatureDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FeatureDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FeatureDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }]; } });

class FeatureService {
    constructor(displayer, dao) {
        this.displayer = displayer;
        this.dao = dao;
    }
    getFeaturesObs() {
        return this.dao.getFeaturesObs();
    }
    getFeaturesIdObs() {
        return this.dao.getFeaturesIdObs();
    }
    setFeature(feature, datas, display = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (display)
                    yield this.displayer.presentLoader("Enregistrement caractéristique en cours ...");
                this.dao.setFeature(feature, datas).then((result) => __awaiter(this, void 0, void 0, function* () {
                    if (display)
                        yield this.displayer.dismissLoader();
                    resolve(result);
                })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                    if (display)
                        yield this.displayer.dismissLoader();
                    reject(err);
                }));
                return this.dao.setFeature(feature, datas);
            }));
        });
    }
    /*async createFeature( feature :Feature, datas:any, display :boolean = true ) :Promise<Feature | null>{
      return this.dao.createFeature( feature, display );
    }
    async updateFeature( feature :Feature, datas:any, display :boolean = true ) :Promise<Feature | null> {
      return this.dao.updateFeature( feature, display );
    }*/
    addValue(feature, value) {
        if (feature.values.includes(value) || value == "" || value == undefined || value == null)
            return false;
        feature.values.push(value);
        return true;
    }
    addFeatureValue(feature) {
        return new Promise((resolve) => {
            switch (feature.type) {
                case "array":
                case "string":
                case "number":
                    this.displayer.presentValueAlert("Ajout " + feature.name, "", feature.nameValue, feature.typeValue, "Entrez une valeur de type " + feature.typeValue).then((value) => __awaiter(this, void 0, void 0, function* () {
                        if (value) {
                            if (feature.values.includes(value)) {
                                this.displayer.presentAlert("Sors tes lunettes...", "Donnée pré-existante", "Regarde mieux, " + value + " est déjà dans la liste.");
                                resolve(null);
                            }
                            else {
                                feature.values.push(value);
                                yield this.setFeature(feature, { values: feature.values });
                                resolve(value);
                            }
                        }
                        else
                            resolve(null);
                    }));
                    break;
                case "map":
                    if (feature.typeValue[1] == "file") {
                        this.displayer.presentValueAlert("Ajout " + feature.name, "", feature.nameValue[0], feature.typeValue[0], "Entrez une valeur de type " + feature.typeValue[0], true).then((value) => __awaiter(this, void 0, void 0, function* () {
                            if (value && value[feature.nameValue[0]]) {
                                if (feature.values.filter(val => { return val[feature.nameValue[0]] == value[feature.nameValue[0]]; }).length > 0) {
                                    this.displayer.presentAlert("Sors tes lunettes...", "Donnée pré-existante", "Regarde mieux, " + value[feature.nameValue[0]] + " est déjà dans la liste.");
                                    resolve(null);
                                }
                                else {
                                    feature.values.push(value);
                                    yield this.setFeature(feature, { values: feature.values });
                                    resolve(value);
                                }
                            }
                            else
                                resolve(null);
                        }));
                    }
                    else {
                        this.displayer.presentMapAlert("Ajout " + feature.name, "", feature.nameValue, feature.typeValue).then((values) => __awaiter(this, void 0, void 0, function* () {
                            if (values[feature.nameValue[0]] && values[feature.nameValue[1]]) {
                                if (feature.values.filter(value => { return value[feature.nameValue[0]] == values[feature.nameValue[0]] && value[feature.nameValue[1]] == values[feature.nameValue[1]]; }).length > 0) {
                                    this.displayer.presentAlert("Sors tes lunettes...", "Donnée pré-existante", "Regarde mieux, " + values[feature.nameValue[0]] + "" + feature.display.separate + "" + values[feature.nameValue[1]] + " est déjà dans la liste.");
                                    resolve(null);
                                }
                                else {
                                    feature.values.push(values);
                                    yield this.setFeature(feature, { values: feature.values });
                                    resolve(values);
                                }
                            }
                            else
                                resolve(null);
                        }));
                    }
                    break;
                default:
                    resolve(null);
            }
        });
    }
}
FeatureService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FeatureService, deps: [{ token: i2.DisplayerService }, { token: FeatureDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
FeatureService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FeatureService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FeatureService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2.DisplayerService }, { type: FeatureDaoService }]; } });

class OrderDaoService {
    constructor(afStore, logger, userService, productService, declinationService) {
        this.afStore = afStore;
        this.logger = logger;
        this.userService = userService;
        this.productService = productService;
        this.declinationService = declinationService;
        this.subscription = null;
    }
    unsubscribe() {
        if (this.subscription != null)
            this.subscription.unsubscribe();
    }
    getOrdersByUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                this.subscription = this.getOrdersByUser$().subscribe(orders => {
                    if (orders)
                        resolve(orders);
                });
            }));
        });
    }
    getOrdersByUser$() {
        console.log("getOrders");
        return combineLatest([
            this.afStore.collection("orders").valueChanges(),
            this.userService.getUser()
        ])
            .pipe(map(([orders, user]) => {
            if (!user)
                return [];
            if (!orders || orders.length == 0)
                return [];
            return orders.filter(order => order.uid === user.uid);
        }), map(orders => {
            console.log("getOrders", orders);
            for (let order of orders) {
                let products = new Map();
                let variations = new Map();
                let productsReturn = new Map();
                let variationsReturn = new Map();
                let categories = new Map();
                let categoriesReturn = new Map();
                for (let p of order.products)
                    products.set(p['id'], p['quantity']);
                for (let p of order.productsReturn)
                    productsReturn.set(p['id'], p['quantity']);
                for (let p of order.variations)
                    variations.set(p['id'], p['quantity']);
                for (let p of order.variationsReturn)
                    variationsReturn.set(p['id'], p['quantity']);
                for (let p of order.categories) {
                    let m = new Map();
                    if (categories.has(p['id']))
                        m = categories.get(p['id']);
                    m.set(p['price'], p['quantity']);
                    categories.set(p['id'], m);
                }
                for (let p of order.categoriesReturn) {
                    let m = new Map();
                    if (categoriesReturn.has(p['id']))
                        m = categoriesReturn.get(p['id']);
                    m.set(p['price'], p['quantity']);
                    categoriesReturn.set(p['id'], m);
                }
                order.products = products;
                order.productsReturn = productsReturn;
                order.variations = variations;
                order.variationsReturn = variationsReturn;
                order.categories = categories;
                order.categoriesReturn = categoriesReturn;
            }
            return orders;
        }));
    }
    getOrderByIdByUser(id) {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            this.subscription = this.getOrderByIdByUser$(id).subscribe(order => {
                resolve(order);
            });
        }));
    }
    getOrderByIdByUser$(id) {
        return combineLatest([
            this.afStore.collection("orders").doc(id).valueChanges(),
            this.userService.getUser()
        ]).pipe(map(([order, user]) => {
            if (order.uid === user.uid)
                return order;
            else
                return null;
        }), map(order => {
            if (order == null)
                return null;
            let products = new Map();
            let variations = new Map();
            let productsReturn = new Map();
            let variationsReturn = new Map();
            let categories = new Map();
            let categoriesReturn = new Map();
            for (let p of order.products)
                products.set(p['id'], p['quantity']);
            for (let p of order.productsReturn)
                productsReturn.set(p['id'], p['quantity']);
            for (let p of order.variations)
                variations.set(p['id'], p['quantity']);
            for (let p of order.variationsReturn)
                variationsReturn.set(p['id'], p['quantity']);
            for (let p of order.categories) {
                let m = new Map();
                if (categories.has(p['id']))
                    m = categories.get(p['id']);
                m.set(p['price'], p['quantity']);
                categories.set(p['id'], m);
            }
            for (let p of order.categoriesReturn) {
                let m = new Map();
                if (categoriesReturn.has(p['id']))
                    m = categoriesReturn.get(p['id']);
                m.set(p['price'], p['quantity']);
                categoriesReturn.set(p['id'], m);
            }
            order.products = products;
            order.productsReturn = productsReturn;
            order.variations = variations;
            order.variationsReturn = variationsReturn;
            order.categories = categories;
            order.categoriesReturn = categoriesReturn;
            return order;
        }));
    }
    getOrdersByTypeByUser(type) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                this.unsubscribe();
                this.subscription = combineLatest([
                    this.afStore.collection("orders").valueChanges(),
                    this.userService.getUser()
                ]).pipe(map(([orders, user]) => orders.filter(order => order.type === type && order.uid === user.uid)), map(orders => {
                    for (let order of orders) {
                        let products = new Map();
                        let variations = new Map();
                        let productsReturn = new Map();
                        let variationsReturn = new Map();
                        let categories = new Map();
                        let categoriesReturn = new Map();
                        for (let p of order.products)
                            products.set(p['id'], p['quantity']);
                        for (let p of order.productsReturn)
                            productsReturn.set(p['id'], p['quantity']);
                        for (let p of order.variations)
                            variations.set(p['id'], p['quantity']);
                        for (let p of order.variationsReturn)
                            variationsReturn.set(p['id'], p['quantity']);
                        for (let p of order.categories) {
                            let m = new Map();
                            if (categories.has(p['id']))
                                m = categories.get(p['id']);
                            m.set(p['price'], p['quantity']);
                            categories.set(p['id'], m);
                        }
                        for (let p of order.categoriesReturn) {
                            let m = new Map();
                            if (categoriesReturn.has(p['id']))
                                m = categoriesReturn.get(p['id']);
                            m.set(p['price'], p['quantity']);
                            categoriesReturn.set(p['id'], m);
                        }
                        order.products = products;
                        order.productsReturn = productsReturn;
                        order.variations = variations;
                        order.variationsReturn = variationsReturn;
                        order.categories = categories;
                        order.categoriesReturn = categoriesReturn;
                    }
                    return orders;
                })).subscribe(orders => {
                    resolve(orders);
                });
            }));
        });
    }
    getOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                this.subscription = this.getOrders$().subscribe(orders => {
                    resolve(orders);
                });
            }));
        });
    }
    getOrders$() {
        return this.afStore.collection("orders").valueChanges()
            .pipe(map((orders) => orders), map(orders => {
            for (let order of orders) {
                let products = new Map();
                let variations = new Map();
                let productsReturn = new Map();
                let variationsReturn = new Map();
                let categories = new Map();
                let categoriesReturn = new Map();
                let payments = new Map();
                for (let p of order.products)
                    products.set(p['id'], p['quantity']);
                if (order.productsReturn)
                    for (let p of order.productsReturn)
                        productsReturn.set(p['id'], p['quantity']);
                for (let p of order.variations)
                    variations.set(p['id'], p['quantity']);
                for (let p of order.variationsReturn)
                    variationsReturn.set(p['id'], p['quantity']);
                for (let p of order.categories) {
                    let m = new Map();
                    if (categories.has(p['id']))
                        m = categories.get(p['id']);
                    m.set(p['price'], p['quantity']);
                    categories.set(p['id'], m);
                }
                for (let p of order.categoriesReturn) {
                    let m = new Map();
                    if (categoriesReturn.has(p['id']))
                        m = categoriesReturn.get(p['id']);
                    m.set(p['price'], p['quantity']);
                    categoriesReturn.set(p['id'], m);
                }
                if (order.payments)
                    for (let p of order.payments) {
                        payments.set(p['type'], p['amount']);
                    }
                order.products = products;
                order.productsReturn = productsReturn;
                order.variations = variations;
                order.variationsReturn = variationsReturn;
                order.categories = categories;
                order.categoriesReturn = categoriesReturn;
                order.payments = payments;
            }
            return orders;
        }));
    }
    getOrderById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                this.unsubscribe();
                this.subscription =
                    this.afStore.collection("orders").doc(id).valueChanges()
                        .pipe(map((order) => order), map(order => {
                        if (order == null)
                            return null;
                        let products = new Map();
                        let variations = new Map();
                        let productsReturn = new Map();
                        let variationsReturn = new Map();
                        let categories = new Map();
                        let categoriesReturn = new Map();
                        for (let p of order.products)
                            products.set(p['id'], p['quantity']);
                        for (let p of order.productsReturn)
                            productsReturn.set(p['id'], p['quantity']);
                        for (let p of order.variations)
                            variations.set(p['id'], p['quantity']);
                        for (let p of order.variationsReturn)
                            variationsReturn.set(p['id'], p['quantity']);
                        for (let p of order.categories) {
                            let m = new Map();
                            if (categories.has(p['id']))
                                m = categories.get(p['id']);
                            m.set(p['price'], p['quantity']);
                            categories.set(p['id'], m);
                        }
                        for (let p of order.categoriesReturn) {
                            let m = new Map();
                            if (categoriesReturn.has(p['id']))
                                m = categoriesReturn.get(p['id']);
                            m.set(p['price'], p['quantity']);
                            categoriesReturn.set(p['id'], m);
                        }
                        order.products = products;
                        order.productsReturn = productsReturn;
                        order.variations = variations;
                        order.variationsReturn = variationsReturn;
                        order.categories = categories;
                        order.categoriesReturn = categoriesReturn;
                        return order;
                    })).subscribe(order => {
                        resolve(order);
                    });
            }));
        });
    }
    getOrdersByType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                this.unsubscribe();
                this.subscription = this.afStore.collection("orders").valueChanges()
                    .pipe(map((orders) => orders.filter(order => order.type === type)), map(orders => {
                    for (let order of orders) {
                        let products = new Map();
                        let variations = new Map();
                        let productsReturn = new Map();
                        let variationsReturn = new Map();
                        let categories = new Map();
                        let categoriesReturn = new Map();
                        for (let p of order.products)
                            products.set(p['id'], p['quantity']);
                        for (let p of order.productsReturn)
                            productsReturn.set(p['id'], p['quantity']);
                        for (let p of order.variations)
                            variations.set(p['id'], p['quantity']);
                        for (let p of order.variationsReturn)
                            variationsReturn.set(p['id'], p['quantity']);
                        for (let p of order.categories) {
                            let m = new Map();
                            if (categories.has(p['id']))
                                m = categories.get(p['id']);
                            m.set(p['price'], p['quantity']);
                            categories.set(p['id'], m);
                        }
                        for (let p of order.categoriesReturn) {
                            let m = new Map();
                            if (categoriesReturn.has(p['id']))
                                m = categoriesReturn.get(p['id']);
                            m.set(p['price'], p['quantity']);
                            categoriesReturn.set(p['id'], m);
                        }
                        order.products = products;
                        order.productsReturn = productsReturn;
                        order.variations = variations;
                        order.variationsReturn = variationsReturn;
                        order.categories = categories;
                        order.categoriesReturn = categoriesReturn;
                    }
                    return orders;
                })).subscribe(orders => {
                    resolve(orders);
                });
            }));
        });
    }
    createId() {
        return this.afStore.createId();
    }
    setOrder(datas, check) {
        return __awaiter(this, void 0, void 0, function* () {
            if (datas.id == "") {
                let id = this.createId();
                datas.id = id;
                return yield this.createOrder(datas, check);
            }
            else
                return yield this.updateOrder(datas, check);
        });
    }
    createOrder(datas, check) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            this.afStore.collection("orders").doc(datas.id).set(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                let quantityOk = true;
                for (let product of datas.products)
                    quantityOk = (quantityOk && (yield this.productService.updateQuantityProduct(product.id, -product.quantity, check)));
                if (!quantityOk) {
                    for (let product of datas.products)
                        yield this.productService.updateQuantityProduct(product.id, product.quantity, check);
                    resolve(null);
                }
                else {
                    for (let variation of datas.variations) {
                        quantityOk = (quantityOk && (yield this.declinationService.updateQuantityDeclination(variation.id, -variation.quantity, check)));
                    }
                    if (!quantityOk) {
                        for (let variation of datas.variations)
                            yield this.declinationService.updateQuantityDeclination(variation.id, variation.quantity, check);
                        resolve(null);
                    }
                    else {
                        for (let product of datas.productsReturn)
                            yield this.productService.updateQuantityProduct(product.id, product.quantity, check);
                        for (let variation of datas.variationsReturn)
                            yield this.declinationService.updateQuantityDeclination(variation.id, variation.quantity, check);
                        resolve(datas);
                    }
                }
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.message(OrderDaoService.name, "create order nok " + err, "error");
                resolve(null);
            }));
        }));
    }
    cancelOrder(datas) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            let now = moment.now().toString();
            let statuts = datas.statuts;
            statuts.push({ name: "canceled", date: now });
            this.afStore.collection("orders").doc(datas.id).update({ statuts: statuts }).then(() => __awaiter(this, void 0, void 0, function* () {
                for (let product of datas.products)
                    yield this.productService.updateQuantityProduct(product[0], product[1], false);
                for (let variation of datas.variations)
                    yield this.declinationService.updateQuantityDeclination(variation[0], variation[1], false);
                for (let product of datas.productsReturn)
                    yield this.productService.updateQuantityProduct(product[0], -product[1], false);
                for (let variation of datas.variationsReturn)
                    yield this.declinationService.updateQuantityDeclination(variation[0], -variation[1], false);
                resolve(datas);
            }));
        }));
    }
    updateOrder(datas, check) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            this.afStore.collection("orders").doc(datas.id).update(datas).then(() => __awaiter(this, void 0, void 0, function* () {
                let quantityOk = true;
                for (let product of datas.products)
                    quantityOk = (quantityOk && (yield this.productService.updateQuantityProduct(product.id, -product.quantity, check)));
                if (!quantityOk) {
                    for (let product of datas.products)
                        yield this.productService.updateQuantityProduct(product.id, product.quantity, check);
                    resolve(null);
                }
                else {
                    for (let variation of datas.variations) {
                        quantityOk = (quantityOk && (yield this.declinationService.updateQuantityDeclination(variation.id, -variation.quantity, check)));
                    }
                    if (!quantityOk) {
                        for (let product of datas.products)
                            yield this.productService.updateQuantityProduct(product.id, product.quantity, check);
                        for (let variation of datas.variations)
                            yield this.declinationService.updateQuantityDeclination(variation.id, variation.quantity, check);
                        resolve(null);
                    }
                    else {
                        for (let product of datas.productsReturn)
                            yield this.productService.updateQuantityProduct(product.id, product.quantity, check);
                        for (let variation of datas.variationsReturn)
                            yield this.declinationService.updateQuantityDeclination(variation.id, variation.quantity, check);
                        resolve(datas);
                    }
                }
            })).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.message(OrderDaoService.name, "update order nok " + err, "error");
                resolve(null);
            }));
        }));
    }
    createOrderFromCart(cart) {
        let amount = 0;
        let products = [];
        for (let product of cart.products)
            products.push({ id: product[0], quantity: product[1] });
        let productsReturn = [];
        for (let product of cart.productsReturn)
            productsReturn.push({ id: product[0], quantity: product[1] });
        let variations = [];
        for (let variation of cart.variations)
            variations.push({ id: variation[0], quantity: variation[1] });
        let variationsReturn = [];
        for (let variation of cart.variationsReturn)
            variationsReturn.push({ id: variation[0], quantity: variation[1] });
        let categories = [];
        for (let category of cart.categories) {
            for (let cat of category[1]) {
                categories.push({ id: category[0], price: cat[0], quantity: cat[1] });
            }
        }
        let categoriesReturn = [];
        for (let category of cart.categoriesReturn) {
            for (let cat of category[1])
                categoriesReturn.push({ id: category[0], price: cat[0], quantity: cat[1] });
        }
        return {
            id: "",
            uid: cart.uid,
            products: products,
            productsReturn: productsReturn,
            variations: variations,
            variationsReturn: variationsReturn,
            categories: categories,
            categoriesReturn: categoriesReturn,
            nbItems: cart.nbItems,
            coupons: cart.coupons,
            payments: [],
            createdAt: moment.now().toString(),
            type: "",
            amount: amount,
            shipping: null,
            priceShipping: 0,
            trackingNumber: "",
            statuts: Array(),
            address: null,
            name: "",
            phone: 0,
        };
    }
    deleteOrder(datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("orders").doc(datas.id).delete().then(() => {
                return true;
            }).catch(err => {
                this.logger.message(OrderDaoService.name, "delete order nok " + err, "error");
                return false;
            });
        });
    }
}
OrderDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrderDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i3.UserService }, { token: ProductService }, { token: DeclinationService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrderDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrderDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i3.UserService }, { type: ProductService }, { type: DeclinationService }]; } });

class OrderService {
    constructor(dao) {
        this.dao = dao;
        this.statutNames = new Map();
        this.orders$ = new BehaviorSubject(null);
        this.subscription = null;
        this.statutNames.set("waitingPayment", "Paiement en attente");
        this.statutNames.set("paid", "Paiement accepté");
        this.statutNames.set("preparation", "Préparation en cours");
        this.statutNames.set("canceled", "Annulée");
        this.statutNames.set("shipped", "Expédiée");
        this.statutNames.set("delivered", "Livrée");
        this.statutNames.set("error", "Erreur");
        this.statutNames.set("restocking", "Réapprovisionnement en cours");
        this.statutNames.set("back", "Retour");
        this.statutNames.set("partialBack", "Retour partiel");
        this.statutNames.set("repaid", "Remboursée");
        this.statutNames.set("shipDeferred", "Expédition différée");
        this.statutNames.set("checking", "Vérification en cours");
        this.statutNames.set("created", "Création");
    }
    unsubscribeDao() {
        this.dao.unsubscribe();
    }
    unsubscribe() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
    createOrderFromCart(cart) {
        return this.dao.createOrderFromCart(cart);
    }
    setOrder(datas, check) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dao.setOrder(datas, check);
        });
    }
    getOrders$() {
        if (!this.subscription)
            this.subscription = this.dao.getOrdersByUser$().subscribe(orders => {
                if (orders)
                    this.orders$.next(orders);
            });
        return this.orders$;
    }
    getOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            let orders = yield this.dao.getOrdersByUser();
            this.unsubscribeDao();
            return orders;
        });
    }
    getOrderById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            let order = yield this.dao.getOrderByIdByUser(id);
            this.unsubscribeDao();
            return order;
        });
    }
    getOrdersByType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            let orders = yield this.dao.getOrdersByTypeByUser(type);
            this.unsubscribeDao();
            return orders;
        });
    }
    getStatutNames() {
        return this.statutNames;
    }
    deleteOrder(datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dao.deleteOrder(datas);
        });
    }
    cancelOrder(datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dao.cancelOrder(datas);
        });
    }
}
OrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrderService, deps: [{ token: OrderDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: OrderDaoService }]; } });

class OrdersService {
    constructor(dao) {
        this.dao = dao;
        this.orders$ = new BehaviorSubject(null);
        this.subscription = null;
        this.subscription = this.dao.getOrders$().subscribe(orders => {
            this.orders$.next(orders);
        });
    }
    unsubscribe() {
        this.dao.unsubscribe();
    }
    getOrders$() {
        /*if( this.subscription == null )
          this.subscription = this.dao.getOrders$().subscribe( orders => {
            this.orders$.next( orders );
          });*/
        return this.orders$;
    }
    getOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            let orders = yield this.dao.getOrders();
            this.unsubscribe();
            return orders;
        });
    }
    getOrderById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dao.getOrderById(id);
        });
    }
    getOrdersByType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.dao.getOrdersByType(type);
        });
    }
    createOrderFromCart(cart) {
        return this.dao.createOrderFromCart(cart);
    }
    setOrder(datas, check = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dao.setOrder(datas, check);
        });
    }
}
OrdersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrdersService, deps: [{ token: OrderDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
OrdersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrdersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OrdersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: OrderDaoService }]; } });

class ShippingDaoService {
    constructor(afStore, logger, displayer, countryService) {
        this.afStore = afStore;
        this.logger = logger;
        this.displayer = displayer;
        this.countryService = countryService;
        this.shippingObs = new BehaviorSubject(null);
        this.shippingByCountryObs = new BehaviorSubject(null);
        this.shippingByIdObs = new BehaviorSubject(null);
        this.afStore.collection("shippings").valueChanges().
            pipe(map(shippings => { return shippings; })).subscribe(shippings => {
            if (shippings) {
                this.shippingObs.next(shippings);
                let shippingById = new Map();
                let shippingByCountry = new Map();
                for (let shipping of shippings) {
                    let shippings = [];
                    shippingById.set(shipping.id, shipping);
                    if (shippingByCountry.has(shipping.country))
                        shippings = shippingByCountry.get(shipping.country);
                    shippings.push(shipping);
                    shippingByCountry.set(shipping.country, shippings);
                }
                this.shippingByCountryObs.next(shippingByCountry);
                this.shippingByIdObs.next(shippingById);
            }
        });
    }
    createId() {
        return this.afStore.createId();
    }
    getShippingsObs() {
        return this.shippingObs;
    }
    getShippingsByCountryObs() {
        return this.shippingByCountryObs;
    }
    getShippingsByIdObs() {
        return this.shippingByIdObs;
    }
    setShipping(pShipping, pDatas) {
        return __awaiter(this, void 0, void 0, function* () {
            if (pShipping.id == "") {
                let id = this.createId();
                pShipping.id = id;
                pDatas.id = id;
                return yield this.createShipping(pShipping, pDatas);
            }
            else {
                return yield this.updateShipping(pShipping, pDatas);
            }
        });
    }
    createShipping(pShipping, pDatas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("shippings").doc(pShipping.id).set(pDatas).then(() => {
                return pShipping;
            }).catch(err => {
                this.logger.message(ShippingDaoService.name, err, "error");
                return null;
            });
        });
    }
    updateShipping(pShipping, pDatas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("shippings").doc(pShipping.id).update(pDatas).then(() => {
                return pShipping;
            }).catch(err => {
                this.logger.message(ShippingDaoService.name, err, "error");
                return null;
            });
        });
    }
}
ShippingDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ShippingDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i2.DisplayerService }, { token: i3.CountryService }], target: i0.ɵɵFactoryTarget.Injectable });
ShippingDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ShippingDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ShippingDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i2.DisplayerService }, { type: i3.CountryService }]; } });

class ShippingService {
    constructor(dao) {
        this.dao = dao;
    }
    getShippingsObs() {
        return this.dao.getShippingsObs();
    }
    getShippingsByCountryObs() {
        return this.dao.getShippingsByCountryObs();
    }
}
ShippingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ShippingService, deps: [{ token: ShippingDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
ShippingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ShippingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ShippingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ShippingDaoService }]; } });

class AddressDaoService {
    constructor(afStore, logger, countryService, profileService) {
        this.afStore = afStore;
        this.logger = logger;
        this.countryService = countryService;
        this.profileService = profileService;
        this.addressObs = new BehaviorSubject(null);
        this.profileService.getUser().subscribe(user => {
            if (user) {
                this.afStore.collection("addresses").doc(user.uid).valueChanges().
                    pipe(map(address => address)).subscribe(address => {
                    if (address)
                        this.addressObs.next(address);
                });
            }
        });
    }
    createId() {
        return this.afStore.createId();
    }
    getAddressObs() {
        return this.addressObs;
    }
    setAddress(address, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            if (address.id == "") {
                let id = this.createId();
                address.id = id;
                datas.id = id;
                return yield this.createAddress(address, datas);
            }
            else {
                return this.updateAddress(address, datas);
            }
        });
    }
    createAddress(address, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("addresses").doc(address.uid).set(datas).then(() => {
                    resolve(address);
                }).catch(err => {
                    this.logger.message(AddressDaoService.name, "create address nok " + err, "error");
                    resolve(null);
                });
            }));
        });
    }
    updateAddress(address, datas) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.afStore.collection("addresses").doc(address.uid).update(datas).then(() => {
                    resolve(address);
                }).catch(err => {
                    this.logger.message(AddressDaoService.name, "update address nok " + err, "error");
                    resolve(null);
                });
            }));
        });
    }
}
AddressDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AddressDaoService, deps: [{ token: i1.AngularFirestore }, { token: i2.LoggerService }, { token: i3.CountryService }, { token: i3.UserService }], target: i0.ɵɵFactoryTarget.Injectable });
AddressDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AddressDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AddressDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AngularFirestore }, { type: i2.LoggerService }, { type: i3.CountryService }, { type: i3.UserService }]; } });

class AddressService {
    constructor(dao, countriesService, logger) {
        this.dao = dao;
        this.countriesService = countriesService;
        this.logger = logger;
        this.subscription = null;
    }
    getAddressObs() {
        return this.dao.getAddressObs();
    }
    setAddress(address, datas) {
        return this.dao.setAddress(address, datas);
    }
    displayAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.subscription = this.countriesService.getCountriesByCode().subscribe(countries => {
                    var _a;
                    if (countries) {
                        let res = "";
                        res += address.street + "<br/>";
                        if (address.additional != "")
                            res += address.additional + "<br/>";
                        if (address.building != "")
                            res += address.building + "<br/>";
                        if (address.compagny != "")
                            res += address.compagny + "<br/>";
                        res += address.codePostal + " " + address.city + "<br/>";
                        if (countries.has(address.country))
                            res += (_a = countries.get(address.country)) === null || _a === void 0 ? void 0 : _a.name;
                        resolve(res);
                        setTimeout(() => {
                            this.unsubscribe();
                        }, 100);
                    }
                });
            });
        });
    }
    unsubscribe() {
        this.logger.message(AddressService.name, "unsubscribe");
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
AddressService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AddressService, deps: [{ token: AddressDaoService }, { token: i3.CountryService }, { token: i2.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
AddressService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AddressService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AddressService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AddressDaoService }, { type: i3.CountryService }, { type: i2.LoggerService }]; } });

class ProductResolver {
    constructor(productService) {
        this.productService = productService;
    }
    resolve(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            let product = null;
            if (route.paramMap.get('id')) {
                let ids = this.productService.getProductsByIdObs().getValue();
                if (ids == null)
                    product = yield this.productService.getProductById(route.paramMap.get('id'));
                else {
                    let prodT = ids.get(route.paramMap.get('id'));
                    if (prodT != undefined)
                        product = prodT;
                }
            }
            return product;
        });
    }
}
ProductResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductResolver, deps: [{ token: ProductService }], target: i0.ɵɵFactoryTarget.Injectable });
ProductResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductResolver, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ProductService }]; } });

class ProductDatasResolver {
    constructor(productService, declinationService, manufacturerService) {
        this.productService = productService;
        this.declinationService = declinationService;
        this.manufacturerService = manufacturerService;
    }
    resolve(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            let product = null;
            let manufacturer = null;
            if (route.paramMap.get('id')) {
                let productsIds = this.productService.getProductsByIdObs().getValue();
                if (productsIds == null)
                    product = yield this.productService.getProductById(route.paramMap.get('id'));
                else {
                    let prodT = productsIds.get(route.paramMap.get('id'));
                    if (prodT != undefined)
                        product = prodT;
                }
                if (product) {
                    let manufacturersIds = this.manufacturerService.getManufacturersIdObs().getValue();
                    if (manufacturersIds == null)
                        manufacturer = yield this.manufacturerService.getManufacturerById(product.manufacturer);
                    else {
                        let manufacturerT = manufacturersIds.get(product.manufacturer);
                        if (manufacturerT != undefined)
                            manufacturer = manufacturerT;
                    }
                }
            }
            return { product: product, manufacturer: manufacturer };
        });
    }
}
ProductDatasResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductDatasResolver, deps: [{ token: ProductService }, { token: DeclinationService }, { token: ManufacturerService }], target: i0.ɵɵFactoryTarget.Injectable });
ProductDatasResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductDatasResolver, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProductDatasResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ProductService }, { type: DeclinationService }, { type: ManufacturerService }]; } });

class DeclinationResolver {
    constructor(declinationService) {
        this.declinationService = declinationService;
    }
    resolve(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            let product = null;
            if (route.paramMap.get('id')) {
                let ids = this.declinationService.getDeclinationsByIdObs().getValue();
                if (ids == null)
                    product = yield this.declinationService.getDeclinationById(route.paramMap.get('id'));
                else {
                    let prodT = ids.get(route.paramMap.get('id'));
                    if (prodT != undefined)
                        product = prodT;
                }
            }
            return product;
        });
    }
}
DeclinationResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationResolver, deps: [{ token: DeclinationService }], target: i0.ɵɵFactoryTarget.Injectable });
DeclinationResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationResolver, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DeclinationResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: DeclinationService }]; } });

class ManufacturerResolver {
    constructor(manufacturerService) {
        this.manufacturerService = manufacturerService;
    }
    resolve(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            let manufacturer = null;
            if (route.paramMap.get('id')) {
                let ids = this.manufacturerService.getManufacturersIdObs().getValue();
                if (ids == null)
                    manufacturer = yield this.manufacturerService.getManufacturerById(route.paramMap.get('id'));
                else {
                    let prodT = ids.get(route.paramMap.get('id'));
                    if (prodT != undefined)
                        manufacturer = prodT;
                }
            }
            return manufacturer;
        });
    }
}
ManufacturerResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerResolver, deps: [{ token: ManufacturerService }], target: i0.ɵɵFactoryTarget.Injectable });
ManufacturerResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerResolver, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ManufacturerResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ManufacturerService }]; } });

/*
 * Public API Surface of octali-lib-shop
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressService, CartService, CategoryService, DeclinationResolver, DeclinationService, FeatureService, ManufacturerResolver, ManufacturerService, OctaliLibShopComponent, OctaliLibShopModule, OctaliLibShopService, OrderService, OrdersService, ProductDatasResolver, ProductResolver, ProductService, ShippingService, VariationService };
